import { merge } from "lodash"
import defaultConfig from "./configuration/default"

export default {
  materialType: "administrative-court-decision",
  title: "label.administrativeCourtDecision",
  description: "description.administrativeCourtDecision",
  languages: [
    "fi",
    "sv",
  ],
  configuration: merge({}, defaultConfig, {
    listing: {
      caption: true,
      title: true,
      type: true,
    },
  }),
}
